module.exports = __webpack_public_path__ + "img/zwsj@2x.15a554b2.png";